import { Injectable } from '@angular/core';
import {Router} from '@angular/router';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {ServiceConfig} from './service-config';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class VPSHostingService {

  private host = ServiceConfig.host;
  private baseUrl = this.host + '/api/vps-hosting/';
  private data: any;
  private headers: Headers;
  private options: {};

  constructor(private http: HttpClient,
              private router: Router) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    // console.log(this.data.token);
    this.headers = new Headers({
      'Content-Type': 'application/json'
    });
    this.options = {headers: this.headers};
  }

  public index() {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + '?token=' + this.data.token;
    return this.http.get<any>(url);
  }

  public create(body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    //console.log(body);
    let url = this.baseUrl + 'create?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public get(username: String) {
    let url = this.baseUrl + username + '?token=' + this.data.token;
    //console.log(url);
    return this.http.get<any>(url);
  }

  public update(id: String, body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + id + '/update?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public delete(id: String) {
    let url = this.baseUrl + id + '/delete?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, this.options);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/vps-hosting.service.ts